export default __webpack_public_path__ + "static/media/Kevins Design Header.c5ddb3b8.jpg";